import React, { forwardRef, useImperativeHandle } from 'react';
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import "./style.less";
import { getPrefixCls } from "../../utils/common";
import moment from 'moment';
import { useToggleVisible } from "../../hooks/useToggleVisible";
var prefixCls = getPrefixCls('SmCopyRight');
var CopyRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$params, _props$schema, _props$schema$params;
  var _useToggleVisible = useToggleVisible(),
    tabVisible = _useToggleVisible.visible,
    toggleVisible = _useToggleVisible.toggleVisible;
  useImperativeHandle(ref, function () {
    return {
      toggleVisible: toggleVisible
    };
  });
  var source = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.source) || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.source);
  var isDev = source === 'development';
  if (!tabVisible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container")
  }, /*#__PURE__*/React.createElement("div", {
    className: 'copy-right copy-right-none'
  }, /*#__PURE__*/React.createElement("div", {
    className: "copy-right-text"
  }, /*#__PURE__*/React.createElement("a", {
    rel: "nofollow",
    target: "_blank",
    href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902001351"
  }, /*#__PURE__*/React.createElement("img", {
    className: "copy-right-icon",
    src: "https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202305/16/b0eba_20230516143339.png",
    alt: ""
  }), "\u6CAA\u516C\u7F51\u5B89\u590731010902001351\u53F7")), /*#__PURE__*/React.createElement("div", {
    className: "copy-right-text"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.gaodun.com/licence/icp.html"
  }, "\u6CAAB2-20160190"), /*#__PURE__*/React.createElement("a", {
    href: "https://www.gaodun.com/licence/ppl.html"
  }, "\u5E7F\u64AD\u7535\u89C6\u8282\u76EE\u5236\u4F5C\u7ECF\u8425\u8BB8\u53EF\u8BC1")), /*#__PURE__*/React.createElement("div", {
    className: "copy-right-text"
  }, "Copyright \xA9 2006-", moment().format('YYYY'), " \u4E0A\u6D77\u9AD8\u987F\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF0CAll Rights Reserved.")));
});
var EnhanceCopyRight = EnhanceComponent(CopyRight);
EnhanceCopyRight.settings = setting;
export default EnhanceCopyRight;